import styled from "@emotion/styled";

const FlexWrapper = styled.div`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const FlexWrapperT1 = styled(FlexWrapper)`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const FlexWrapperT2 = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;
export const FlexWrapperT3 = styled("div")`
  display: flex;
  gap: 5px;
  align-items: center;
`;
export const FlexWrapperT4 = styled("div")`
  display: flex;
  gap: 10px;
`;

export const FlexWrapperT5 = styled("div")`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
`;

export const FlexWrapperT6 = styled("div")`
  display: flex;
  gap: 20px;
`;

export const FlexWrapperT7 = styled(FlexWrapper)`
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const FlexWrapperT8 = styled("div")`
  display: flex;
  gap: 20px;
`;
export const FlexWrapperT9 = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
`;
export const FlexWrapperT10 = styled("div")`
  display: flex;
  gap: 50px;
  flex-wrap: wrap;
`;
export const FlexWrapperT11 = styled("div")`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
`;
export const FlexWrapperT12 = styled("div")`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const FlexWrapperT13 = styled("div")`
display: flex;
align-items: center;
justify-content: space-between;
gap: 10px;
flex-wrap: wrap;
`;

export const FlexWrapperT14 = styled("div")`
display: flex;
gap: 10px;
flex-wrap: wrap;
`;